import { useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { TableBody } from "../TablesBasePage/TableBody";
import { TableHeader } from "../TablesBasePage/TableHeader";

const headerDefinitions = {
  header: [
    {
      columns: [
        {
          title: "",
          path: "name",
          disabled: true,
          filtered: false,
          type: "string",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "OutsideDiameter",
          translationKey: "tables.carryelements.OutsideDiameter",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "InnerDiameter",
          translationKey: "tables.carryelements.InnerDiameter",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "CrossSectArea",
          translationKey: "tables.carryelements.CrossSectArea",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "UltimateLoad",
          translationKey: "tables.carryelements.UltimateLoad",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          visible: false,
          type: "number",
          path: "CharacteristicLoadCarryingCapcityAccordingToGermanApprovalDocument",
          translationKey:
            "tables.carryelements.CharacteristicLoadCarryingCapcityAccordingToGermanApprovalDocument",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "CharacteristicLoadCarryingCapacity",
          translationKey: "tables.carryelements.CharacteristicLoadCarryingCapacity",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "StrainStiffness",
          translationKey: "tables.carryelements.StrainStiffness",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "BendingStiffness",
          translationKey: "tables.carryelements.BendingStiffness",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "Weight",
          translationKey: "tables.carryelements.Weight",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          visible: false,
          type: "array",
          path: "Length",
          translationKey: "tables.carryelements.Length",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          visible: false,
          type: "array",
          path: "LeftRightThread",
          translationKey: "tables.carryelements.LeftRightThread",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "FySteel",
          translationKey: "tables.carryelements.FySteel",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "holeDiameter",
          translationKey: "tables.carryelements.holeDiameter",
          translationNamespace: "tables",
        },
      ],
    },
    {
      columns: [
        {
          disabled: true,
          filtered: false,
          type: "string",
          path: "name",
          translationKey: "tables.carryelements.name",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "OutsideDiameter",
          translationKey: "tables.units.in",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "InnerDiameter",
          translationKey: "tables.units.in",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "CrossSectArea",
          translationKey: "tables.units.in2",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "UltimateLoad",
          translationKey: "tables.units.kip",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          visible: false,
          type: "number",
          path: "CharacteristicLoadCarryingCapcityAccordingToGermanApprovalDocument",
          translationKey: "tables.units.kip",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "CharacteristicLoadCarryingCapacity",
          translationKey: "tables.units.kip",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "StrainStiffness",
          translationKey: "tables.units.kip",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "BendingStiffness",
          translationKey: "tables.units.ksi",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "Weight",
          translationKey: "tables.units.lbft",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          visible: false,
          type: "array",
          path: "Length",
          translationKey: "tables.units.in",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          visible: false,
          type: "array",
          path: "LeftRightThread",
          translationKey: "tables.carryelements.LeftRightThread_f",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "FySteel",
          translationKey: "tables.units.ksi",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "number",
          path: "holeDiameter",
          translationKey: "tables.units.in",
          translationNamespace: "tables",
        },
      ],
    },
  ],
};

export default function CarryingElements({ functions: carryingElementFunctions }) {
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 20;

  const { isLoading, data: elements } = carryingElementFunctions.GetAll();

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    let res = elements?.slice(firstPageIndex, lastPageIndex);
    if (res?.length === 0 && currentPage !== 1) setCurrentPage(currentPage - 1);
    return res;
  }, [pageSize, currentPage, elements]);

  if (isLoading) return <div>Loading Table...</div>;

  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          {!isLoading && (
            <>
              <TableHeader headerDefs={headerDefinitions} />
              <TableBody
                columns={headerDefinitions.header[0].columns}
                currentTableData={currentTableData}
                functions={carryingElementFunctions}
              />
            </>
          )}
        </table>
      </div>

      {elements && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={elements?.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
}
